import { request_list, export_list } from '@/commons/hpod';
var FileSaver = require('file-saver');
import Vue from 'vue';
// initial state
const state = {
    loading: false,
    revenues: {}
};

// getters
const getters = {};

// actions
const actions = {    
    getRevenueReport({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('report/revenue-report', data => {
            commit('setRevenueReport', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    exportList({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list('report/revenue-report', res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
            FileSaver.saveAs(blob, `bao_cao_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export_list');
    },
};

// mutations
const mutations = {
    setRevenueReport(state, data) {
        state.revenues = data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
